import React, { useEffect, useState } from "react";
import {
  Box,
  Paper,
  Typography,
  Button,
  Snackbar,
  Alert,
} from "@mui/material";
import { useNavigate, useLocation } from "react-router-dom";
import SidebarMenu from "../Administrador/AdminPanel/SidebarMenu";
import TopBar from "../Administrador/AdminPanel/TopBar";
import InfoMotion from "./MotionForm/InfoMotion";
import InventoryDetail from "./MotionForm/InventoryDetail";

const authHeaders = () => {
  const token =
    localStorage.getItem("access") ||
    localStorage.getItem("access_token") ||
    localStorage.getItem("token") ||
    "";

  return token ? { Authorization: `Bearer ${token}` } : {};
};

const Motion = () => {
  const [open, setOpen] = useState(false);
  const [submenuOpen, setSubmenuOpen] = useState(false);
  const [motionInfo, setMotionInfo] = useState({});
  const [productRows, setProductRows] = useState([]);
  const [saving, setSaving] = useState(false);

  const [snackbar, setSnackbar] = useState({
    open: false,
    type: "success",
    message: "",
  });

  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const ok =
      localStorage.getItem("is_superuser") === "true" ||
      localStorage.getItem("is_admin") === "true" ||
      localStorage.getItem("is_vendedor") === "true";

    if (!ok) navigate("/login");
  }, [location, navigate]);

  const handleSave = async () => {
    if (saving) return;

    const inv = motionInfo?.inventario || {};
    const tipoUI = String(inv.tipo || "INGRESO").toUpperCase();
    const tipo = tipoUI === "SALIDA" ? "EGR" : "ING";
    const selectedBodegaId = inv.bodega_id || inv.bodega || "";

    if (!selectedBodegaId) {
      setSnackbar({
        open: true,
        type: "error",
        message: "Seleccione una bodega",
      });
      return;
    }

    const items = (productRows || [])
      .filter((r) => String(r.producto_id || "").trim() || String(r.codigo || "").trim())
      .map((r) => ({
        producto_id: String(r.producto_id || "").trim() || null,
        variant_id:
          r.variant_id !== undefined &&
          r.variant_id !== null &&
          String(r.variant_id).trim() !== ""
            ? r.variant_id
            : null,
        bodega_id: selectedBodegaId,
        codigo: r.codigo || "",
        codigo_principal: r.codigo_principal || r.codigo || "",
        codigo_auxiliar: r.codigo_auxiliar || "",
        sku: r.sku || "",
        variant_value: r.variant_value || "",
        cantidad: Number(r.cantidad || 0),
        costo_unitario: Number(String(r.costo_unitario || "0").replace(",", ".")),
        stock_actual: Number(r.stock_actual || 0),
        stock_final: Number(r.stock_final || 0),
        descripcion: r.nombre || "",
      }));

    const payload = {
      tipo,
      fecha: inv.fecha || "",
      referencia: inv.referencia || "",
      descripcion: inv.descripcion || "",
      bodega_id: selectedBodegaId,
      items,
    };

    setSaving(true);

    try {
      const r = await fetch("/inventario/registrar/", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          ...authHeaders(),
        },
        body: JSON.stringify(payload),
      });

      const j = await r.json().catch(() => ({}));

      if (!r.ok) {
        throw new Error(j.error || "No se pudo guardar el movimiento");
      }

      const message =
        j?.message ||
        (tipo === "ING"
          ? "Ingreso de inventario registrado correctamente"
          : "Egreso de inventario registrado correctamente");

      sessionStorage.setItem(
        "inventory_updated_snackbar",
        JSON.stringify({ type: "success", message })
      );

      navigate("/admin-panel/inventario/movimientos", {
        state: {
          refresh: true,
          snackbar: { type: "success", message },
        },
      });
    } catch (e) {
      setSnackbar({
        open: true,
        type: "error",
        message: e?.message || "No se pudo guardar el movimiento",
      });
    } finally {
      setSaving(false);
    }
  };

  const selectedBodegaId =
    motionInfo?.inventario?.bodega_id || motionInfo?.inventario?.bodega || "";

  return (
    <Box sx={{ display: "flex", minHeight: "100vh", background: "#f5f6fa" }}>
      <SidebarMenu
        open={open}
        setOpen={setOpen}
        submenuOpen={submenuOpen}
        setSubmenuOpen={setSubmenuOpen}
        navigate={navigate}
      />

      <Box sx={{ flexGrow: 1 }}>
        <TopBar open={open} setOpen={setOpen} />

        <Box sx={{ p: 3 }}>
          <Paper sx={{ p: 3, borderRadius: 2 }}>
            <Typography variant="h6" sx={{ fontWeight: 700, color: "#1565C0", mb: 2 }}>
              Registrar Movimiento de Inventario
            </Typography>

            <InfoMotion onChange={setMotionInfo} />

            <InventoryDetail
              inventarioTipo={motionInfo?.inventario?.tipo}
              bodegaId={selectedBodegaId}
              onMotionDataChange={setMotionInfo}
              productRows={productRows}
              setProductRows={setProductRows}
            />

            <Box sx={{ display: "flex", justifyContent: "flex-end", mt: 3 }}>
              <Button
                variant="contained"
                sx={{ bgcolor: "#1565C0", textTransform: "none" }}
                disabled={saving}
                onClick={handleSave}
              >
                {saving ? "Guardando..." : "Guardar"}
              </Button>
            </Box>
          </Paper>
        </Box>
      </Box>

      <Snackbar
        open={snackbar.open}
        autoHideDuration={3000}
        onClose={() => setSnackbar({ ...snackbar, open: false })}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
      >
        <Alert
          severity={snackbar.type}
          onClose={() => setSnackbar({ ...snackbar, open: false })}
          sx={{ width: "100%" }}
        >
          {snackbar.message}
        </Alert>
      </Snackbar>
    </Box>
  );
};

export default Motion;